import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private darkTheme = false;
  private readonly storageKey = 'darkTheme';

  constructor() {
    const savedTheme = localStorage.getItem(this.storageKey);
    // Always start new users in the light theme. An explicit saved preference
    // is still respected and can be changed through the theme switch.
    this.darkTheme = savedTheme === 'true';
    this.applyTheme();
  }

  toggleTheme(): void {
    this.setTheme(!this.darkTheme);
  }

  setTheme(useDarkTheme: boolean): void {
    this.darkTheme = useDarkTheme;
    localStorage.setItem(this.storageKey, String(this.darkTheme));
    this.applyTheme();
  }

  isDarkTheme(): boolean {
    return this.darkTheme;
  }

  private applyTheme(): void {
    const theme = this.darkTheme ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', theme);
    document.documentElement.style.colorScheme = theme;
    document.body.setAttribute('data-theme', theme);
    document.body.classList.toggle('dark-theme', this.darkTheme);
    document.body.classList.toggle('light-theme', !this.darkTheme);
  }
}
